module.exports = __webpack_public_path__ + "img/storenum.69ad6ffd.png";